module.exports = __webpack_public_path__ + "static/img/hover_btn_wx.7ff70ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaguo/hover_btn_wx.png
// module id = 1/uW
// module chunks = 1